import EditScreenInfo from "../components/EditScreenInfo";
// import { Text, View } from "../components/Themed";
import { RootTabScreenProps } from "../types";

import awsconfig from "../aws-exports";
Amplify.configure(awsconfig);


import React, { Component, useState, useEffect } from "react";
import { Button, Text, View, TouchableOpacity, StyleSheet, ScrollView, Dimensions, useWindowDimensions } from "react-native";

import { Amplify, Auth, Hub, API, graphqlOperation } from "aws-amplify";
import { withAuthenticator } from "aws-amplify-react-native";
import { GraphQLQuery } from "@aws-amplify/api";
import { createSettingsAPI, updateSettingsAPI, deleteSettingsAPI } from "../graphql/mutations";
import { getSettingsAPI, listSettingsAPIS, syncSettingsAPIS } from "../graphql/queries";
import { ListSettingsAPISQueryVariables, ListSettingsAPISQuery, CreateSettingsAPIInput, CreateSettingsAPIMutation, UpdateSettingsAPIMutation, DeleteSettingsAPIMutation, GetSettingsAPIQuery } from '../graphql/settingsAPI';

import { UserAgent } from "amazon-cognito-identity-js";
import { background } from "native-base/lib/typescript/theme/styled-system";

// COMMENT: Return userId to prevent creating a duplicate record in dynamoDB
async function getUserId(user) {
  const UserSettings = await API.graphql<GraphQLQuery<GetSettingsAPIQuery>>(graphqlOperation(getSettingsAPI, {id: user.attributes.sub})).then(console.log("WORKING: getuserId", {id: user.attributes.sub})).catch((error) => console.log("ERROR: getUserId:", error));
  if(UserSettings) {
    // console.log("USER_SETTINGS_FOUND:", JSON.stringify(UserSettings, null, 2));
    return UserSettings.data.getSettingsAPI.id;
  } else {
    console.log("USER_SETTINGS_NOT_FOUND:", JSON.stringify(UserSettings, null, 2));
  }
  
}

// COMMENT: add the cognito users infomation to the settingsAPI table in dynamoDB so the userid can be used for transaction logging
async function setSettingsAPI(user) {
    // console.log("PREUSER:", user);
    const setting: CreateSettingsAPIInput = { id: user.attributes.sub, username: user.username, email: user.attributes.email, phone_number: user.attributes.phone_number, sub: user.attributes.sub, user: user };
    // console.log("SETTING:", setting);
    // const createSetting = await API.graphql<GraphQLQuery<CreateSettingsAPIMutation>>(graphqlOperation(createSettingsAPI, {input: setting})).then(console.log("WORKING: setSettingsAPI")).catch((error) => console.log("ERROR: createSetting:", error));
    const createSetting = await API.graphql<GraphQLQuery<CreateSettingsAPIMutation>>(graphqlOperation(createSettingsAPI, {input: setting}))
    .catch ((AmazonServiceException) => {
      console.log("ERROR: createSetting: Could not complete operation");
      console.log("ERROR: createSetting: AmazonServiceException:", AmazonServiceException);
    }
    ).catch ((AmazonClientException) => {
      console.log("ERROR: createSetting: Internal error occurred communicating with DynamoDB");
      console.log("ERROR: createSetting: AmazonClientException:", AmazonClientException);
    })
    .catch((error) => console.log("ERROR: createSetting:", error));
    // NOTE: THIS MEANS THE RECORD ALREADY EXISTS IN DYNAMODB. TODO: update catch // ERROR: createSetting: {"data": {"createSettingsAPI": null}, "errors": [{"data": null, "errorInfo": null, "errorType": "ConditionalCheckFailedException", "locations": [Array], "message": "The conditional request failed (Service: DynamoDb, Status Code: 400, Request ID: 102JF760UHDJN7D3DVOD34513NVV4KQNSO5AEMVJF66Q9ASUAAJG)", "path": [Array]}]}
}


function UsersScreen({
  navigation,
}: RootTabScreenProps<"Users">) {
  const [user, setUser] = useState(null);
  const windowDimensions = Dimensions.get("window");
  const screenDimensions = Dimensions.get("screen");
  const { height, width, scale, fontScale } = useWindowDimensions();
  const [today, setToday] = useState(Date);

  useEffect(() => {
    Auth.currentAuthenticatedUser({ bypassCache: true })
      .then(user => setUser(user))
      .catch(() => setUser(null));
  }, []);

  if (user) {
    const userId = getUserId(user);
    if(userId) {

    } else {
      setSettingsAPI(user);
    }
    return (
      <View style={styles.container}>
        {/* <Button onPress={ () => navigation.navigate('Training')} title="Go to Second Page"/> */}
        <View style={styles.dimensions}>
        <Text>Height: {height}</Text>
        <Text>Width: {width}</Text>
        <Text>Font scale: {fontScale}</Text>
        <Text>Pixel ratio: {scale}</Text>
        </View>

        <View style={styles.attributes}>
        <Text style={styles.header}>Welcome, {user.username}!</Text>
        <Text>EMAIL: {user.attributes.email}</Text>
        <Text>Phone: {user.attributes.phone_number}</Text>
        <Text>Cognito ClientId: {user.attributes.sub}</Text>
        {/* <Text>EMAIL: {user.signInUserSession.idToken.payload.email}</Text>
        <Text>Client ID: {user.pool.clientId}</Text> */}
        </View>

        <ScrollView>
        <Text style={styles.json}>{ JSON.stringify(user, null, 2) }</Text>
        {/* { console.log(JSON.stringify(user, null, 2) )} */}
        </ScrollView>
      </View>
    );
  } else {
    return (
      <View>
        {/* <Text>Not authenticated.</Text> */}
      </View>
    );
  }
}

export default withAuthenticator(UsersScreen, true);


const styles = StyleSheet.create({
  container: {
    // padding: 10,
    // marginTop: 3,
    // backgroundColor: "white",
    // alignItems: "center",
    flex: 1,
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: "#4f603c",
  },
  json: {
    marginTop: 10,
    backgroundColor: "#FF5733",
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
  },
  // json: {
  //   marginTop: 10,
  //   backgroundColor: "#FF5733",
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   padding: 10,
  // },
  dimensions: {
    marginTop: 10,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: "#33CAFF",
  },
  attributes: {
    marginTop: 10,
    backgroundColor: "#FF3399",
  },
});


